import { render, staticRenderFns } from "./stockReport.vue?vue&type=template&id=4cb7bcf2&scoped=true"
import script from "./stockReport.vue?vue&type=script&lang=js"
export * from "./stockReport.vue?vue&type=script&lang=js"
import style0 from "./stockReport.vue?vue&type=style&index=0&id=4cb7bcf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb7bcf2",
  null
  
)

export default component.exports